// PortfolioDetails.js
import React from 'react';
import { Row, Col, Input, Space } from 'antd';
import Button from '@mui/material/Button';
import {SaveRounded, WarningAmberRounded} from "@mui/icons-material";
import ContextualStat from "../../../Components/ContextualStat";
import {CheckCircleFilled, WarningFilled} from "@ant-design/icons";


const CorrelationRanges = [
    {min: -100, max: -30, tag: "Inverse"},
    {min: -30, max: 30, tag: "Weak"},
    {min: 30, max: 100, tag: "Strong"}
]


const VolatilityTagProps = {
    aboveValue: {
        value: 30,
        color: '#EB7E7E'
    },
    belowValue: {
        value: 30,
        color: '#02AF50'
    },
    ranges: [
        {min: 0, max: 10, tag: "Low"},
        {min: 10, max: 30, tag: "Medium"},
        {min: 30, max: 100, tag: "High"}
    ],
    AboveIcon: WarningFilled,
    BelowIcon: CheckCircleFilled

}

const BetaTagProps = {
    aboveValue: {
        value: 100,
        color: '#EB7E7E'
    },
    belowValue: {
        value: 100,
        color: '#02AF50'
    },
    ranges: [
        {min: 0, max: 100, tag: "Low"},
        {min: 100, max: 1000, tag: "High"},
    ],
    AboveIcon: WarningFilled,
    BelowIcon: CheckCircleFilled

}

const BattingAverageTagProps = {
    aboveValue: {
        value: 50,
        color: '#02AF50'
    },
    belowValue: {
        value: 50,
        color: '#EB7E7E'
    },
    ranges: [
        {min: 0, max: 50, tag: "Poor"},
        {min: 50, max: 100, tag: "Good"},
    ],
}


const PortfolioDetails = ({ title, onTitleChange, onSave, isNew, portfolioStats, extraLeft }) => {
  // Determine the status based on whether the title is empty
  const inputStatus = title === '' ? 'error' : 'success';

  return (
      <Row justify={'space-between'}>
          <Space size={'middle'}>
              {extraLeft}
            <Input
                placeholder="Portfolio Title"
                value={title}
                onChange={(e) => onTitleChange(e.target.value)}
                status={inputStatus}
                style={{width: 300}}
            />
                <Button size={'small'} startIcon={<SaveRounded/>} variant={'contained'}  className={'action'} onClick={()=>onSave({saveAsNew: true})}>
                    Save as New
                </Button>
                {isNew===false && (
                    <Button variant={'outlined'}
                            color={'error'}
                            onClick={()=>onSave({saveAsNew: false})}
                            startIcon={<WarningAmberRounded/>}
                    >
                        Update Existing
                    </Button>
                )}
          </Space>
          {portfolioStats && (
              <Space size={'large'}>
                  <ContextualStat value={portfolioStats.threeMonthVol} label={'3 Month Volatility'} {...VolatilityTagProps} suffix={'%'} />
                  <ContextualStat value={portfolioStats.oneYearBetaSpy} label={'Beta S&P 1Y'} {...BetaTagProps} suffix={'%'} />
                  <ContextualStat value={portfolioStats.oneYearCorrSpy} label={'Corr S&P 1Y'} ranges={CorrelationRanges} suffix={'%'} />
                  <ContextualStat value={portfolioStats.oneYearCorrEfa} label={'Corr EFA 1Y'} ranges={CorrelationRanges} suffix={'%'} />
              </Space>
          )}

      </Row>
  );
};
export default PortfolioDetails;